import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityLocalidadesIDEState,
  entityLocalidadesIDEAdapter
} from './entity-localidades-ide.state';

const { selectEntities, selectAll } =
  entityLocalidadesIDEAdapter.getSelectors();

export const getError = (state: EntityLocalidadesIDEState): any => state.error;

export const getIsLoading = (state: EntityLocalidadesIDEState): boolean =>
  state.isLoading;

export const selectLocalidadesIDEState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.localidadesIDE
);

export const selectAllLocalidadesIDE = createSelector(
  selectLocalidadesIDEState,
  selectAll
);
export const selectEntitiesLocalidadesIDE = createSelector(
  selectLocalidadesIDEState,
  selectEntities
);

export const selectLocalidadesIDEByDepartamento = (departamento: string) =>
  createSelector(selectAllLocalidadesIDE, (localidades) =>
    localidades.filter((localidad) => localidad.departamento === departamento)
  );

// MemoizedSelector<object,any>
export const selectLocalidadesIDEError = createSelector(
  selectLocalidadesIDEState,
  getError
);

// MemoizedSelector<object,any>
export const selectLocalidadesIDEIsLoading = createSelector(
  selectLocalidadesIDEState,
  getIsLoading
);
